import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-gamepad-line text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-foreground-900 whitespace-nowrap">暴躁少女CSGO</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              B站暴躁少女CSGO视频专题站，汇聚CSGO精彩操作、搞笑集锦、新手教学与赛事资讯。发现更多值得关注的视频内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#video-categories" className="hover:text-primary-500 transition-colors">视频分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#quick-links" className="hover:text-primary-500 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="https://www.bilibili.com" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  B站官网
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#contact-info" className="hover:text-primary-500 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-foreground-500"></i>
                <span>contact@baozhaocsgo.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-bilibili-line text-foreground-500"></i>
                <a href="https://www.bilibili.com" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-primary-500 transition-colors duration-200">
                  B站：暴躁少女
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 B站暴躁少女CSGO视频专题站. 本站为粉丝自发创建的专题资讯站，与B站官方及暴躁少女本人无直接关联。所有视频内容版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.bilibili.com" target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200">
              <i className="ri-weibo-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}